import ReactSelect from "react-select";
import { CommonDropDownService } from "../../service/CommonDropDownService";
import { useEffect, useState } from "react";
import { AuthService } from "../../service/AuthService";
import EventService from "../../service/EventService";
import { EventCredentialsSevice } from "../../service/EventCredentialsService";


function UserForm(){

    const [selectedCountry, setSelectedCountry] = useState([]);
    const [country, setCountry] = useState([]);
    const [errors, setErrors] = useState({});

    const handleCountry = (e) => {
        if (e) {
            setSelectedCountry(e);
        }
    }
    const getCountryList = async (value) => {
        try {
            const response = await CommonDropDownService.getCountry();
            response ? setCountry(response) : setCountry([]);
            if (value && response) {
                response.filter(function (f) {
                    if (parseInt(f.value) === value) {
                        var ddData = { label: f.label, value: f.value };
                        setSelectedCountry(ddData);
                    }
                })
            }
        } catch (error) {

        }
    }
    const handleRegister = async (e) => {
        try {
            e.preventDefault();
            // Collect form data
            const formData = new FormData(e.target);
            const data = Object.fromEntries(formData);
            const newErrors = {};
            if (!data.username) newErrors.username = 'UserName is required';
            if (!data.mobile) newErrors.mobile = 'Mobile is required';
            if (!data.email) newErrors.email = 'Email is required';
            if (!data.password0) newErrors.password0 = 'password0 is required';
            if (!data.password1) newErrors.password1 = 'password1 is required';
            if (!data.password2) newErrors.password2 = 'password2 is required';
            if (!data.password3) newErrors.password3 = 'password3 is required';
            if (!data.password4) newErrors.password4 = 'password4 is required';
            if (!data.password5) newErrors.password5 = 'password5 is required';
            if (!data.password6) newErrors.password6 = 'password6 is required';
            if (!data.password7) newErrors.password7 = 'password7 is required';
            if (!data.password8) newErrors.password8 = 'password8 is required';
            if (!data.password9) newErrors.password9 = 'password9 is required';
            if (!data.country) newErrors.country = 'Country is required';
            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }   
            setErrors({});
            const formdata = {
                CountryName:selectedCountry.label,
                CountryID:  parseInt(selectedCountry.value),
                UserName: data.username,
                UserMobileNumber: data.mobile,
                UserEmailID: data.email,
                Password0: data.password0,
                Password1: data.password1,
                Password2: data.password2,
                Password3: data.password3,
                Password4: data.password4,
                Password5: data.password5,
                Password6: data.password6,
                Password7: data.password7,
                Password8: data.password8,
                Password9: data.password9,
            }
                const response = await EventCredentialsSevice.EventCreadential(formdata)
                if (response) {
                    alert("Sent successfully.");
                    e.target.reset();
                    setSelectedCountry(null);
                    setErrors({});
                }
                else {
                    alert("Something went wrong.");
                }
        } catch (error) {
            console.log(error)
        }
    };

    function handleSubmit(e){
        e.preventDefault();
    }
    useEffect(() => {
        getCountryList();
    }, []);

    return (
        <div>
            
            <div className="container w-full h-full mb-2">
                    <div className="flex flex-col relative justify-center items-center gap-2 w-full h-full">
                        <h1 className="font-sans font-bold text-2xl sm:text-4xl my-5">Event login form</h1>
                       
                        <form id="form" onSubmit={handleRegister} className="shadow-sm relative shadow-gray-800 rounded-xl border-t-[1px] border sm:w-1/2 w-11/12 flex flex-col gap-2 p-8">
                        
                        {/* username */}
                        <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Username:</label>
                                <input name="username" className="w-4/5 h-8 border border-black px-2 py-1 rounded-md" placeholder="Username..." />
                                {
                                    errors.username && <p className="text-red-500">{errors.username}</p>
                                }
                            </div>
                            {/* mobile */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Mobile:</label>
                                <input name="mobile" pattern="^[1-9]{1}[0-9]{9}$" type="number" className="w-4/5 h-8 border border-black px-2 py-1 rounded-md" placeholder="Mobile..." />
                                {
                                    errors.mobile && <p className="text-red-500">{errors.mobile}</p>
                                }
                            </div>.,56 
                            {/* email */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Email:</label>
                                <input name="email" type="email" className="w-4/5 h-8 border border-black px-2 py-1 rounded-md" placeholder="Email..." />
                                {
                                    errors.email && <p className="text-red-500">{errors.email}</p>
                                }
                            </div>
                            {/* password0 */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Password0:</label>
                                <input name="password0" className="w-4/5 h-8 border border-black px-2 py-1 rounded-md" placeholder="Password0..." />
                                {
                                    errors.password0 && <p className="text-red-500">{errors.password0}</p>
                                }
                            </div>
                            {/* password1 */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Password1:</label>
                                <input name="password1" className="w-4/5 h-8 border border-black px-2 py-1 rounded-md" placeholder="password1..." />
                                {
                                    errors.password1 && <p className="text-red-500">{errors.password1}</p>
                                }
                            </div>
                            {/* password2 */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Password2:</label>
                                <input name="password2"  className="w-4/5 h-8 border border-black px-2 py-1 rounded-md" placeholder="password2..." />
                                {
                                    errors.password2 && <p className="text-red-500">{errors.password2}</p>
                                }
                            </div>
                            {/* password3 */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Password3:</label>
                                <input name="password3" className="w-4/5 h-8 border border-black px-2 py-1 rounded-md" placeholder="password3..." />
                                {
                                    errors.password3 && <p className="text-red-500">{errors.password3}</p>
                                }
                            </div>
                            {/* password4 */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Password4:</label>
                                <input name="password4" className="w-4/5 h-8 border border-black px-2 py-1 rounded-md" placeholder="password4..." />
                                {
                                    errors.password4 && <p className="text-red-500">{errors.password4}</p>
                                }
                            </div>
                            {/* password5 */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Password5:</label>
                                <input name="password5" className="w-4/5 h-8 border border-black px-2 py-1 rounded-md" placeholder="password5..." />
                                {
                                    errors.password5 && <p className="text-red-500">{errors.password5}</p>
                                }
                            </div>
                            {/* password6 */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Password6:</label>
                                <input name="password6" className="w-4/5 h-8 border border-black px-2 py-1 rounded-md" placeholder="password6..." />
                                {
                                    errors.password6 && <p className="text-red-500">{errors.password6}</p>
                                }
                            </div>
                            {/* password7 */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Password7:</label>
                                <input name="password7" className="w-4/5 h-8 border border-black px-2 py-1 rounded-md" placeholder="password7..." />
                                {
                                    errors.password7 && <p className="text-red-500">{errors.password7}</p>
                                }
                            </div>
                            {/* password8 */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Password8:</label>
                                <input name="password8" className="w-4/5 h-8 border border-black px-2 py-1 rounded-md" placeholder="password8..." />
                                {
                                    errors.password8 && <p className="text-red-500">{errors.password8}</p>
                                }
                            </div>
                            {/* password9 */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Password9:</label>
                                <input name="password9" className="w-4/5 h-8 border border-black px-2 py-1 rounded-md" placeholder="password9..." />
                                {
                                    errors.password9 && <p className="text-red-500">{errors.password9}</p>
                                }
                            </div>
                            {/* country field */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Country:</label>
                                
                                <ReactSelect
                                name="country"
                                value={selectedCountry}
                                className="w-4/5 h-10 outline-none rounded-md"
                                onChange={(e) => handleCountry(e)}
                                options={country}
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? 'blue' : 'black',
                                        boxShadow: state.isFocused ? '0 0 0 1px blue' : 'none',
                                        '&:hover': {
                                          borderColor: 'blue',
                                        },
                                      }),
                                    input: (base) => ({
                                      ...base,
                                      'input:focus': {
                                        boxShadow: 'none',
                                      },
                                    }),
                                  }}
                                />
                                {
                                    errors.country && <p className="text-red-500">{errors.country}</p>
                                }
                            </div>
                            {/* Submit button */}
                            <button type="submit" className="border border-orange-500 w-32 hover:bg-orange-600 bg-orange-500 text-white p-2 mt-5 rounded-md">Submit</button>
                        </form>
                    </div>
                </div>
        </div>
    )
}

export default UserForm;